import React, { Fragment } from 'react';

const GOOGLE_TAG_MANAGER_ID = {
  PROD: 'GTM-K7GFJTV',
  DEV: 'GTM-PD8S23G',
};

export const GoogleTagManagerScript = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const nonce = '_NONCE_PLACEHOLDER_0Nzk3LTk2NTEtNjhjNTc4N2RlZTA1';

  const googleTagManagerId = isProduction
    ? GOOGLE_TAG_MANAGER_ID.PROD
    : GOOGLE_TAG_MANAGER_ID.DEV;

  return (
    <Fragment>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
          `,
        }}
        nonce={nonce}
      />

      <script
        async={true}
        nonce={nonce}
        src={`https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`}
      />

      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleTagManagerId}');
          `,
        }}
        nonce={nonce}
      />
    </Fragment>
  );
};
